import React from "react";

/**
 * * For development purposes only
 */

const JsonPrint = ({ data, disable = false }) => {
  if (disable) {
    return null;
  }

  return <pre>{JSON.stringify(data, undefined, 2)}</pre>;
};

export default JsonPrint;



// WEBPACK FOOTER //
// ./src/core/admin/components/Preview/JsonPrint.js